var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Page", {
        attrs: { title: _vm.pageTitle, isFullWidth: true },
        scopedSlots: _vm._u([
          {
            key: "action",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "Polaris-Page-Header__PrimaryActionWrapper" },
                  [
                    _c("div", {
                      staticClass: "Polaris-Box Polaris-Box--printHidden"
                    })
                  ]
                )
              ]
            },
            proxy: true
          },
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-col max-w-7xl mx-auto my-10" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
                      },
                      [
                        _c("div", { staticClass: "flex flex-col" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 "
                            },
                            [
                              _c("div", { staticClass: "Polaris-Grid" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "Polaris-Grid-Cell Polaris-Grid-Cell--cell_6ColumnXs Polaris-Grid-Cell--cell_3ColumnSm Polaris-Grid-Cell--cell_3ColumnMd Polaris-Grid-Cell--cell_6ColumnLg Polaris-Grid-Cell--cell_6ColumnXl"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "Polaris-LegacyCard" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "Polaris-CalloutCard__Container"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "Polaris-LegacyCard__Section Polaris-LegacyCard__FirstSectionPadding Polaris-LegacyCard__LastSectionPadding"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "Polaris-CalloutCard"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "Polaris-CalloutCard__Content"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "Polaris-CalloutCard__Title"
                                                          },
                                                          [
                                                            _c(
                                                              "h2",
                                                              {
                                                                staticClass:
                                                                  "Polaris-Text--root Polaris-Text--headingMd"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Welcome Notification "
                                                                ),
                                                                _c("Badge", {
                                                                  attrs: {
                                                                    title: _vm.getBadgeTitle(
                                                                      "welcomeNotification"
                                                                    ),
                                                                    type: _vm.getBadgeType(
                                                                      "welcomeNotification"
                                                                    )
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "Polaris-TextContainer"
                                                          },
                                                          [
                                                            _c("p", [
                                                              _vm._v(
                                                                " A sequence of notifications sent to the subscriber once they subscribe to your store notifications "
                                                              )
                                                            ])
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "Polaris-CalloutCard__Buttons"
                                                          },
                                                          [
                                                            _c(
                                                              "router-link",
                                                              {
                                                                staticClass:
                                                                  "Polaris-Button",
                                                                attrs: {
                                                                  to:
                                                                    "/welcomenotifications",
                                                                  "data-polaris-unstyled":
                                                                    "true"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "Polaris-Button__Content"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "Polaris-Button__Text"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Customize"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    ),
                                                    _c("img", {
                                                      staticClass:
                                                        "Polaris-CalloutCard__Image",
                                                      attrs: {
                                                        alt: "",
                                                        src:
                                                          "https://instaimages.carthike.com/pushhike/welcome_notification.svg"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "Polaris-Grid-Cell Polaris-Grid-Cell--cell_6ColumnXs Polaris-Grid-Cell--cell_3ColumnSm Polaris-Grid-Cell--cell_3ColumnMd Polaris-Grid-Cell--cell_6ColumnLg Polaris-Grid-Cell--cell_6ColumnXl"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "Polaris-LegacyCard" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "Polaris-CalloutCard__Container"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "Polaris-LegacyCard__Section Polaris-LegacyCard__FirstSectionPadding Polaris-LegacyCard__LastSectionPadding"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "Polaris-CalloutCard"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "Polaris-CalloutCard__Content"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "Polaris-CalloutCard__Title"
                                                          },
                                                          [
                                                            _c(
                                                              "h2",
                                                              {
                                                                staticClass:
                                                                  "Polaris-Text--root Polaris-Text--headingMd"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Abandoned Cart "
                                                                ),
                                                                _c("Badge", {
                                                                  attrs: {
                                                                    title: _vm.getBadgeTitle(
                                                                      "abandonedCartNotification"
                                                                    ),
                                                                    type: _vm.getBadgeType(
                                                                      "abandonedCartNotification"
                                                                    )
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "Polaris-TextContainer"
                                                          },
                                                          [
                                                            _c("p", [
                                                              _vm._v(
                                                                " A sequence of notifications to remind the subscriber about the items they forgot in their cart "
                                                              )
                                                            ])
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "Polaris-CalloutCard__Buttons"
                                                          },
                                                          [
                                                            _c(
                                                              "router-link",
                                                              {
                                                                staticClass:
                                                                  "Polaris-Button",
                                                                attrs: {
                                                                  to:
                                                                    "/abandonedcart",
                                                                  "data-polaris-unstyled":
                                                                    "true"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "Polaris-Button__Content"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "Polaris-Button__Text"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Customize"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    ),
                                                    _c("img", {
                                                      staticClass:
                                                        "Polaris-CalloutCard__Image",
                                                      attrs: {
                                                        alt: "",
                                                        src:
                                                          "https://instaimages.carthike.com/pushhike/abandoned_cart.svg"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "Polaris-Grid-Cell Polaris-Grid-Cell--cell_6ColumnXs Polaris-Grid-Cell--cell_3ColumnSm Polaris-Grid-Cell--cell_3ColumnMd Polaris-Grid-Cell--cell_6ColumnLg Polaris-Grid-Cell--cell_6ColumnXl"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "Polaris-LegacyCard" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "Polaris-CalloutCard__Container"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "Polaris-LegacyCard__Section Polaris-LegacyCard__FirstSectionPadding Polaris-LegacyCard__LastSectionPadding"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "Polaris-CalloutCard"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "Polaris-CalloutCard__Content"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "Polaris-CalloutCard__Title"
                                                          },
                                                          [
                                                            _c(
                                                              "h2",
                                                              {
                                                                staticClass:
                                                                  "Polaris-Text--root Polaris-Text--headingMd"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Order Shipping Update "
                                                                ),
                                                                _c("Badge", {
                                                                  attrs: {
                                                                    title:
                                                                      "Early Access",
                                                                    type: "info"
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "Polaris-TextContainer"
                                                          },
                                                          [
                                                            _c("p", [
                                                              _vm._v(
                                                                " Notification will be sent once the order is fulfilled along with the tracking URL "
                                                              )
                                                            ])
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "Polaris-CalloutCard__Buttons"
                                                          },
                                                          [
                                                            !_vm.store
                                                              .hasAccessForOrderNotification
                                                              ? _c(
                                                                  "button",
                                                                  {
                                                                    staticClass:
                                                                      "Polaris-Button",
                                                                    attrs: {
                                                                      to:
                                                                        "/ordershipping",
                                                                      "data-polaris-unstyled":
                                                                        "true"
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        _vm.earlyAccessInterest
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "Polaris-Button__Content"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "Polaris-Button__Text"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Get Early Access"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.store
                                                              .hasAccessForOrderNotification
                                                              ? _c(
                                                                  "router-link",
                                                                  {
                                                                    staticClass:
                                                                      "Polaris-Button",
                                                                    attrs: {
                                                                      to:
                                                                        "/ordershipping",
                                                                      "data-polaris-unstyled":
                                                                        "true"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "Polaris-Button__Content"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "Polaris-Button__Text"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Customize"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    ),
                                                    _c("img", {
                                                      staticClass:
                                                        "Polaris-CalloutCard__Image",
                                                      attrs: {
                                                        alt: "",
                                                        src:
                                                          "https://instaimages.carthike.com/pushhike/shipping_update.svg"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "Polaris-Grid-Cell Polaris-Grid-Cell--cell_6ColumnXs Polaris-Grid-Cell--cell_3ColumnSm Polaris-Grid-Cell--cell_3ColumnMd Polaris-Grid-Cell--cell_6ColumnLg Polaris-Grid-Cell--cell_6ColumnXl"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "Polaris-LegacyCard" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "Polaris-CalloutCard__Container"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "Polaris-LegacyCard__Section Polaris-LegacyCard__FirstSectionPadding Polaris-LegacyCard__LastSectionPadding"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "Polaris-CalloutCard"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "Polaris-CalloutCard__Content"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "Polaris-CalloutCard__Title"
                                                          },
                                                          [
                                                            _c(
                                                              "h2",
                                                              {
                                                                staticClass:
                                                                  "Polaris-Text--root Polaris-Text--headingMd"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Campaigns "
                                                                ),
                                                                _c("Badge", {
                                                                  attrs: {
                                                                    title:
                                                                      "Coming Soon",
                                                                    type: "info"
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "Polaris-TextContainer"
                                                          },
                                                          [
                                                            _c("p", [
                                                              _vm._v(
                                                                " Send a personalized push notifications to your customer list. "
                                                              )
                                                            ])
                                                          ]
                                                        ),
                                                        _c("div", {
                                                          staticClass:
                                                            "Polaris-CalloutCard__Buttons"
                                                        })
                                                      ]
                                                    ),
                                                    _c("img", {
                                                      staticClass:
                                                        "Polaris-CalloutCard__Image",
                                                      attrs: {
                                                        alt: "",
                                                        src:
                                                          "https://instaimages.carthike.com/pushhike/shipping_update.svg"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    )
                  ]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }